import './AddressesPage.scss'

import { Button } from 'antd'
import { AppRoutes } from 'App'
import AddressCard from 'components/address-card/AddressCard'
import Spinner from 'components/spinner/Spinner'
import { useAdreslerimQuery } from 'gql/GeneratedGraphqlTypes'
import { useNavigate } from 'react-router-dom'

const AddressesPage = () => {
  const navigate = useNavigate()
  const { data, error, loading, refetch } = useAdreslerimQuery({ fetchPolicy: 'network-only' })

  if (loading) {
    return <Spinner showSpinner={loading} color={'red'}></Spinner>
  }

  if (error) {
    console.log(error)
  }

  if (!data) {
    return null
  }

  return (
    <div className="addresses-page">
      <div className="header">
        <h3>Adreslerim</h3>
        <Button
          className="add-address-button"
          type={'primary'}
          onClick={() => {
            navigate(`/${AppRoutes.account.root}/${AppRoutes.account.addAddress}`)
          }}
        >
          + Yeni Adres Ekle
        </Button>
      </div>
      <div className="addresses-list">
        {data.profil?.adresler?.map((adres) => (
          <AddressCard key={adres && adres.id} data={adres} onDeleted={refetch} />
        ))}
      </div>
    </div>
  )
}

export default AddressesPage
